import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { isPwaStandalonForced } from '@df/module-pwa/pwa-const';
import { Customer } from '@df/session/api/customer';
import { LocalCustomerModel } from '../customer/customer.model.decorator';

/**
 * Resolver to refresh Antavo customer data when visiting account routes
 * Throttled to max once per minute
 *
 * Use this resolver on any account route where you want to refresh Antavo data
 * Example: /account/my-outfits, /account/my-missions, /account/my-rewards
 */
export const accountAntavoRefreshResolver: ResolveFn<void> = async () => {
    if (!isPwaStandalonForced) {
        return;
    }

    const customer = inject(Customer);

    try {
        const customerModel = (await customer.model.load()) as LocalCustomerModel;

        if (customerModel?.loyaltyId) {
            await customerModel.refreshAntavoMemberStatusThrottled();
        }
    } catch (error) {
        console.error('Failed to refresh Antavo customer data:', error);
    }
};
